<template>
    <div>
        <tsoft-table
            :name="'orderLogistic'"
            :api="tableApiUrlChooser()"
            :items.sync="items"
            :isNeedSearch="true"
            :isNeedCreate="false"
            :isNeedSelection="false"
            :headerContextMenuName="headerContextMenuName"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            @copy="copyItem"
            @score="scoreItem"
            @createOrderBillFromAction="createOrderBillFromAction"
            @createOrderFinanceRequestFromAction="createOrderFinanceRequestFromAction"
            @openOrderDocumentsFromAction="openOrderDocumentsFromAction"
            @openServiceDistributionModal="openServiceDistributionModal"
            :key="tableComponentRefreshKey"
            :onDataEmptyMessage="onDataEmptyMessage"
            :typeOfTableFilter="typeOfTableFilter"
            :customAddButtonName="'Создать заявку'"
            :additionalGetParameter="additionalGetParameter()"

            :needFilter="needFilter"
            :specificApiRequest="specificApiRequest"
        ></tsoft-table>

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
            lazy
        >
            <template #title>
                <div class="title-sidebar">
                    <button
                        class="btn btn-outline-blue"
                        @click="openCreateTaskSidebar"
                    >Создать задачу</button>
                    <strong class="ml-4">Детальная информация</strong>
                </div>
            </template>
            <tsoft-order-show-one
                :detailedItemIndex="detailedItemIndex"
                :detailedItem="detailedItem"
                @closeOrder="closeOrderByIndex"
                @changeOrderStatus="changeOrderStatusByID"
                @changeCreatorUserId="changeCreatorUserId"
                @updateOneOrder="updateOneOrder"
            ></tsoft-order-show-one>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </b-sidebar>

        <tsoft-order-service-distribution
            :isOpenServiceDistributionModal.sync="isOpenServiceDistributionModal"
            :editIndex="editIndex"
            :editedItem="editedItem"
            @updateOneOrder="updateOneOrder"
        ></tsoft-order-service-distribution>

        <tsoft-order-scoring
            :openScoreBoxIndex="openScoreBoxIndex"
            :openScoreBoxItemId="openScoreBoxItemId"
            :scoringItemClose="scoringItemClose"
        ></tsoft-order-scoring>

        <b-modal
            id="order-documents-help-modal"
            title="Памятка по документам при оформлении заказа"
            v-model="openHelp"
            hide-footer
        >
            <p><em>Список документов дан максимально исчерпывающий, не все из перечисленных документов обязательны для оформления услуг:</em></p>
            <p><strong>Для заявок ТЭО:</strong></p>
            <ul clas="disc-lists">
                <li>Заявка на перевозку,</li>
                <li>Прочие документы (например MSDS и т.д.)<br />Транспортную накладную (AWB, B/L, CMR, ж/д накладную)</li>
            </ul>
            <p><strong>Для заявок ТО:</strong></p>
            <ul class="disc-lists">
                <li>Контракт</li>
                <li>Дополнительное соглашение</li>
                <li>Спецификация</li>
                <li>Инвойс</li>
                <li>Упаковочный лист</li>
                <li>Техническое описание товара</li>
                <li>SWIFT (п/п об оплате продавцу за товар, если условиями контракта предусмотрен авансовый платеж)</li>
                <li>Экспортная декларация</li>
                <li>Сертификация</li>
                <li>Транспортная накладная (AWB, BL, CMR, ж/д накладная)</li>
                <li>Договор транспортных услуг.</li>
                <li>Счет за транспорт.</li>
                <li>П/п на таможню пошлина.</li>
                <li>П/п на таможню аванс.</li>
                <li>Прайс-лист.</li>
                <li>Страхование.</li>
                <li>Прочие затраты, которые включаются в таможенную стоимость (pick-up до порта/аэропорта/транспортного узла или терминала, ПРР в стране отправления, проведение сюрвейерских проверок, испытание и тестирование оборудования и пр.)</li>
            </ul>
            <b-button class="mt-3 float-right" @click="$bvModal.hide('order-documents-help-modal')">Закрыть</b-button>
        </b-modal>
        <OrderCreateModal @created-order="unshiftNewOrder" />

        <CreateTaskWidget
            :orderId="detailedItem.id"
            @openCreateTaskSidebar="openCreateTaskSidebar"
        />
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import eventBus from "@/eventBuses/eventBus.js";

    import {
        API_GET_ORDERS_SERVICES_V2_LOGISTICS,
        API_POST_NOTIFICATIONS_READ_BY_SERVICE_REFERENCE_ID,
        API_POST_NOTIFICATIONS_ORDERS_READ,
        API_EMPLOYEES
    } from "@/constants";

    import tsoftOrderShowOne from  "@components/orders/OrderShowOne";
    import tsoftOrderServiceDistribution from "@components/orders/OrderServiceDistribution";
    import tsoftCreateCompany from "@components/companies/CreatedOrEditedCompany";
    import tsoftOrderScoring from "@components/orders/OrderScoring";
    import OrderCreateModal from "@components/orders/OrderCreateModal";
    import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        actionCopyItem,
        actionScoreItem,
        orderMethods,
        changeCommasOnDots
    } from "@/mixins";
    import { openOrderSidebar } from "@/mixins/openOrderSidebar";
    import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';

    const initialEditedItem = () => ({
        id: '',
        text_mark: null,
        bitrix_deal_id: null,        
        creator_user_id: '',
        creator: {},
        company_employee_id: '',
        company_employee: {
            id: '',
            lead_fio: '',
            lead_email: '',
            lead_phone: '',
        },
        reference_order_type_id: 1,
        type: {},
        company_id: '',
        company: {},
        temp_name: '',
        client: {},
        set_categories_ids: [],             // Virtual for setting up categories
        categories: [],
        set_services_ids: [],               // Virtual for setting up services
        services: [],
        reference_status_id: 359,
        status: {},
        receive_datetime: null,
        processing_end_datetime: null,
        comment: '',
        reference_close_reason_id: '',
        close_reason: {},
        close_comment: '',
        documents: [],
        short_order: false,
        optional_sales_manager_user_id: '',
        optional_sales_manager: {},
        outsourcing_order: 0,
        outsourcing_type_name: 'Нет',
        reference_sources_id: '',
        predictable_mp: null,
        related_orders: []
    })

    export default {
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            actionCopyItem,
            actionScoreItem,
            orderMethods,
            changeCommasOnDots,
            openOrderSidebar,
            openCreateTaskSidebar,
        ],
        components: {
            "tsoft-order-show-one": tsoftOrderShowOne,
            "tsoft-order-service-distribution": tsoftOrderServiceDistribution,
            "tsoft-create-company": tsoftCreateCompany,
            "tsoft-order-scoring": tsoftOrderScoring,
            OrderCreateModal,
            CreateTaskWidget,
        },
        props: {
            companyId: { type: Number | String, required: false, default: '' },         //company id for showing orders
            needFilter: { type: Boolean, default: true },
            specificApiRequest: { type: Object }
        },
        data() {
            return {
                isSideBarOpenCompany: false,
                tableApiUrl: '',
                tableComponentRefreshKey: 0,
                typeOfTableFilter: 'order-service-logistic',
                editedItemEmployees: {
                    employees: [],
                    loading: false,
                    addNew: false
                },
                editedItemDocumentIdsFromCompany: [],
                openHelp: false,
                headerContextMenuName: 'orderServiceLogisticTable',
            }
        },

        computed: {
            ...mapGetters("orderDetail", ["orderWidgetValue", "orderChangedColumns"])
        },

        mounted() {
            this.editedItem = initialEditedItem()
        },
        created() {
            eventBus.$on('update-one-logistic-order', this.updateOneOrder);
        },
        mounted() {
            this.editedItem = initialEditedItem()
        },
        destroyed() {
            eventBus.$off('update-one-logistic-order', this.updateOneOrder);
        },
        watch: {
            '$route.path'() {
                this.tableApiUrl = this.tableApiUrlChooser()
                this.tableComponentRefreshKey++
            },

            orderWidgetValue(value) {
              let updated_item = this.items.data.filter(item => item.id === value.id)[0]
              updated_item = Object.assign(updated_item, value)
            },

            orderChangedColumns() {
              this.tableComponentRefreshKey += 1
            },

            "editedItem.receive_datetime": function(value) {
                this.editedItem.receive_datetime = value ?
                    this.$moment(value).format('YYYY-MM-DDTHH:mm') :
                    null
            },

            "editedItem.processing_end_datetime": function(value) {
                this.editedItem.processing_end_datetime = value ?
                    this.$moment(value).format('YYYY-MM-DDTHH:mm') :
                    null
            },

            "editedItem.company_id": function(value) {
                this.loadCompanyEmployees(this.editedItem.company_id)
            },

            "editedItem.set_services_ids": function(services_ids) {
                this.editedItemDocumentIdsFromCompany = []

                services_ids.forEach((id, index) => {
                    this.editedItemDocumentIdsFromCompany.push(SERVICE_TO_DOCUMENT[id])
                })
            },

            "editedItem.company_employee.lead_fio": function(inputtedFio) {
                let similarIndex = this.editedItemEmployees.employees.findIndex((employee, index, array) => {
                    if (employee.lead_fio == inputtedFio) {
                        return true
                    }
                    return false
                })

                if (similarIndex != -1) {
                    this.editedItemEmployees.addNew = false
                } else {
                    this.editedItemEmployees.addNew = true
                }
            },

            "editedItem.short_order": function(status) {
                this.editedItem.short_order = (status == 1) ? true : false
            }
        },
        methods: {
            beforeSidebarOpenedCallback() {
              this.$root.$emit("bv::toggle::collapse", "create-order-modal");
            },
            unshiftNewOrder(order) {
              this.items.data.unshift(order)
            },

            tableApiUrlChooser() {
                let apiUrl = API_GET_ORDERS_SERVICES_V2_LOGISTICS
                this.onDataEmptyMessage = 'Таблица заказов по услуге пуста. Сначала необходимо добавить хотя бы один заказ.'
                this.typeOfTableFilter = 'order-service-logistic'
                this.clearServiceNotificationList(this.$route.params.service_id)

                return apiUrl
            },

            additionalGetParameter() {
                if (this.companyId) {
                    return `&only_this_company_orders=${this.companyId}`
                }

                return ''
            },

            clearServiceNotificationList: async function(service_id) {
                const response = await api.call('post', API_POST_NOTIFICATIONS_READ_BY_SERVICE_REFERENCE_ID + `/${service_id}`)
                this.$store.dispatch('GET_NOTIFICATIONS')
            },

            clearOrdersNotificationList: async function(service_id) {
                const response = await api.call('post', API_POST_NOTIFICATIONS_ORDERS_READ, {
                    place: 'left_menu'
                })
                this.$store.dispatch('GET_NOTIFICATIONS')
            },

            createOrderBillFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-finance"]')
            },

            createOrderFinanceRequestFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-finance-requests"]')
            },

            openOrderDocumentsFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-documents"]')
            },

            openServiceDistributionModal(index) {
                this.editIndex = index
                this.editedItem = { ...this.items.data[index] }
                this.isOpenServiceDistributionModal = true
            },

            loadCompanyEmployees(company_id) {
                this.editedItemEmployees.loading = true
                if (company_id) {
                    api.call("get", `${API_EMPLOYEES}/?company_id=${company_id}`).then(({data}) => {
                        this.editedItemEmployees.employees = data.data
                    }).finally(() => {
                        this.editedItemEmployees.loading = false
                    })
                } else {
                    this.editedItemEmployees.loading = false
                }
            },

            // call update one order from action mixin
            updateOneOrder(id = -1) {
                let index = this.findElementIndexById(id)

                if (index !== -1) {
                    let id = this.items.data[index].id
                    api.call("get", `${API_GET_ORDERS_SERVICES_V2_LOGISTICS}/${id}`).then(({data}) => {
                        this.items.data[index] = Object.assign(this.items.data[index], data)
                    }).finally(() => {
                    })
                }
            },

            setClosedSidePanelCompany(){
                this.editedItem = initialEditedItem()
                this.editedItemEmployees.employees = []
                this.editIndex = -1
            },

            changeCreatorUserId(id, data, index) {
                this.dataOverlay = true
                this.updateAnyOrder(id, data, index).then(() => {
                    this.dataOverlay = false
                })
            }
        }
    }

</script>

<style scoped>
.disc-lists {
  list-style: disc;
  margin-left: 25px;
}
</style>
